import { Injectable } from '@angular/core';
import { environment } from '@app-environments/environment';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { Observable } from 'rxjs';

function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root',
})
export class RazorpayapiService extends RestApiService {
  apiUrl = 'https://api.razorpay.com/v1';

  get nativeWindow(): any {
    return getWindow();
  }

  checkIsUPICorrect(payload: any): any {
    // const url = this.apiUrl + `/payments/validate/account?key_id=${environment.razorkey}`;
    const url = this.apiUrl + `/payments/validate/vpa`;
    const headers = {
      'Authorization': 'Basic ' + btoa('rzp_test_bdl4VmVzbXjfI8:gS27YxFRipSIRvygyq8iu8YL')
    };
    return this.post(url, payload, headers);
  }
}
